import { isAnyOf } from '@reduxjs/toolkit'
import { setManCode, takeSnapshot, truckConfigurationSlice } from '#app/store/slices/configurationSlice'
import { createInitialSelection } from '#pages/Configuration/utils/utils'
import type { AppMiddleware } from '../configurationRequestMiddleware'

const matcher = isAnyOf(truckConfigurationSlice.actions._placeConfiguration.match, setManCode.match)

export const configurationSnapshotListener = (middleware: AppMiddleware) => {
  middleware.startListening({
    matcher: matcher,
    effect: (action, listenerApi) => {
      if (truckConfigurationSlice.actions._placeConfiguration.match(action)) {
        // only take snapshots for configurations that change their step
        if (action.payload.reason !== 'step-setting') {
          return
        }

        const {
          configuration: {
            id,
            step: { view },
            version,
            productGroups,
            configuredFamilies,
          },
        } = action.payload
        listenerApi.dispatch(
          takeSnapshot({
            id: id,
            view: view,
            version: version,
            productGroups: productGroups,
            reason: 'current-state',
            initialSelection: createInitialSelection(action.payload.configuration),
            configuredFamilies: configuredFamilies,
          }),
        )
      }

      if (setManCode.match(action)) {
        const { id } = action.payload
        const configuration = listenerApi.getState().truckConfigurations.configurations[id]
        if (!configuration) {
          return
        }
        const {
          step: { view },
          version,
          productGroups,
          configuredFamilies,
        } = configuration
        listenerApi.dispatch(
          takeSnapshot({
            id: id,
            view: view,
            version: version,
            productGroups: productGroups,
            reason: 'man-code',
            initialSelection: createInitialSelection(configuration),
            configuredFamilies: configuredFamilies,
          }),
        )
      }
    },
  })
}
